export const PaymentType = {
  Credit: 'credit',
  Convenience: 'convenience'
} as const

export type PaymentTypes = (typeof PaymentType)[keyof typeof PaymentType]
